import { withInstall } from '@tw-element/utils'
import Switch from './src/switch.vue'

export const TwSwitch = withInstall(Switch)
export default TwSwitch

export * from './src/switch'
